var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10875",
    "data-name": "Group 10875",
    transform: "translate(0.106 -0.249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4229",
    "data-name": "Rectangle 4229",
    width: 54,
    height: 53,
    transform: "translate(-0.106 0.249)",
    fill: "#d9261c",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44739",
    "data-name": "Path 44739",
    d: "M53.26,27.63A25.63,25.63,0,1,0,22.5,52.747V35.319H17.378V27.63H22.5V21.222a8.98,8.98,0,0,1,8.97-8.97h6.407v7.689H32.756A2.571,2.571,0,0,0,30.193,22.5V27.63h7.689v7.689H30.193V53.131A25.626,25.626,0,0,0,53.26,27.63",
    transform: "translate(-1.076 -0.381)",
    fill: "#d9261c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.2c45c5b98d8576c2a307896597b348c0.svg";
export { ForwardRef as ReactComponent };